<template>
  <div>
    <Header2 class="fixed-bar" style="z-index: 100" :version="1" />
    <div class="block1-bg overflow-hidden" :style="$store.state.signinStatus && $vuetify.breakpoint.width < 1280 ? { height: 'auto' } : {}">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" md="6" align="left" class="px-4 px-sm-6 px-md-4 pr-md-0 pr-sm-4">
            <div class="text-h5 text-sm-h4 text-md-h3 font-weight-black deep-purple--text text--darken-4 mt-8 mt-md-15" :style="$vuetify.breakpoint.width > 959.89 ? { lineHeight: '51px' } : $vuetify.breakpoint.width < 475 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block1.title }}
            </div>
            <div class="text-h5 text-sm-h4 text-md-h3 font-weight-black deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width > 959.89 ? { lineHeight: '51px' } : $vuetify.breakpoint.width < 475 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block1.title2 }}
            </div>
            <div class="text-md-h5 my-6">
              {{ block1.desc }}
            </div>
            <v-btn color="primary" rounded x-large outlined class="shareBtn mr-2 mb-2" @click="showShare = true">
              <v-icon class="mr-1" size="21">mdi-share-variant</v-icon>
              <span class="font-weight-bold">分享小芋頭平台</span>
            </v-btn>
            <v-btn color="#1ba252" style="border-color: #1ba252" rounded x-large outlined class="shareBtn mb-2" @click="AddLine()">
              <v-img :src="lineLogo" width="20" hegiht="20" class="mr-1"></v-img>
              <span class="font-weight-bold">加入小芋頭平台LINE好友</span>
            </v-btn>
            <br />
            <v-btn color="#448AFF" style="border-color: #448aff" rounded x-large class="shareBtn mb-2 mr-2" @click="GoRouter('SignUp')">
              <v-icon class="mr-1" size="21" color="white">mdi-account-plus</v-icon>
              <span class="font-weight-bold white--text">加入會員</span>
            </v-btn>
            <v-sheet color="purple lighten-5" class="py-3 px-4 rounded-pill d-inline-flex align-center" elevation="0">
              <v-icon class="mr-2" size="21" color="purple">mdi-sprout</v-icon>
              <div class="d-flex align-center">
                <div class="purple--text text--darken-2 font-weight-bold">小芋頭會員人數：</div>
                <div class="text-h6 purple--text text--darken-3 font-weight-black line-height-1">
                  {{ accountCounts }}
                </div>
              </div>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="6" class="px-0 d-flex align-center">
            <SkeletonImg :src="block1.img" class="block1-img-lg"></SkeletonImg>
            <SkeletonImg :src="block1.img2" class="block1-img-sm" contain></SkeletonImg>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- <div v-if="!$store.state.signinStatus" align="center" class="pt-6">
      <div class="text-h5 font-weight-bold">{{ quickForward.title }}</div>
      <v-container class="py-6">
        <v-row class="d-flex justify-center">
          <v-col cols="4" md="3" class="pa-2" v-for="x in quickForward.items" :key="x.text">
            <v-hover v-slot="{ hover }">
              <v-card class="d-sm-flex pa-1 px-sm-3 py-sm-4 pa-md-5 justify-center justify-sm-start quick-go" :class="{ 'on-hover': hover }" elevation="0" @click="GoRouter(x.url)">
                <div align="center">
                  <v-img :src="x.img" width="38" height="38" contain></v-img>
                </div>
                <div class="ml-sm-3 mt-3 mt-sm-0" :align="$vuetify.breakpoint.width < 600 ? 'center' : 'left'">
                  <div class="text-body-2 font-weight-bold">{{ x.text }}</div>
                  <div class="d-none d-sm-flex text-body-2 text--secondary">
                    {{ x.desc }}
                  </div>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-container>
    </div> -->

    <v-container class="pt-10">
      <div align="center">
        <!-- YouTube 影片自適應 16:9 (使用 v-responsive 確保 RWD 比例正確) -->
        <v-responsive :aspect-ratio="16 / 9" class="rounded-xl mb-4" style="max-width: 1280px; overflow: hidden">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/3iW6gbsvYkI?si=ldPSZzicUbLMvSti&vq=hd1080"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </v-responsive>
        <!-- 手機也用同一張，照畫面寬度等比例縮小 -->
        <SkeletonImg :src="image_alliance" class="rounded-xl" contain max-width="1280" :aspect-ratio="1707 / 960" />

        <div class="mid-title my-4">2026年引資上曜集團透過台保大控股公司於2~3年IPO上市櫃</div>

        <SkeletonImg :src="image_lg2" class="rounded-xl image-lg" contain max-width="1280" />
        <SkeletonImg :src="image_sm2" class="rounded-xl image-sm" contain />
      </div>
    </v-container>

    <div class="d-flex justify-center">
      <div class="home-block">
        <div class="d-flex justify-center">
          <div class="home-block-icon-bg">
            <v-icon color="#304FFE">mdi-domain</v-icon>
          </div>
        </div>
        <div align="center" class="d-flex justify-center align-center">
          <div class="home-subtitle">
            <span>勞動法務智慧管理</span>
          </div>
        </div>
      </div>
    </div>

    <v-container class="pt-6 px-4">
      <div align="center" class="mb-5">
        <v-img :src="logo30" max-width="327"></v-img>
        <div class="ai-title text-left mt-4">
          <span v-html="formatTitle('免費金豐勞動法務AI智能諮詢系統(隨身LLA勞動法務顧問師，人資管理的最強大腦）')"></span>
          <div class="free-tag">
            <span class="text">免費贈送</span>
            <span class="shine"></span>
          </div>
        </div>
        <div class="d-flex mt-5 text-left">
          <span class="mr-3">
            <v-icon small>mdi-check-circle</v-icon>
            個人名片
          </span>
          <span class="mr-3">
            <v-icon small>mdi-check-circle</v-icon>
            AI客服
          </span>
          <span>
            <v-icon small>mdi-check-circle</v-icon>
            智能培訓
          </span>
        </div>
        <div class="d-flex text-left mt-5 mb-4 ai-sub">平台將以業界最低價格協助企業進入AI企業領域，正式方案敬請期待！</div>

        <template>
          <v-row justify="center">
            <v-col cols="12" sm="6" md="4" v-for="x in blockAI" :key="x.title" class="d-flex flex-column">
              <div class="ai-card pa-3 pt-4 flex-grow-1">
                <div class="d-flex">
                  <div class="mr-2">
                    <v-img :src="x.icon" height="38" width="38" class="rounded-lg"></v-img>
                  </div>
                  <div class="d-flex text-left text-h6 font-weight-bold">
                    <span v-html="formatTitle(x.title)"></span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <div class="my-2">
                    <v-img :src="x.img" max-height="168" contain></v-img>
                  </div>
                  <div class="mb-4">
                    <ul v-if="x.listType === 'ul'" class="text-left" style="font-size: 18px">
                      <li v-for="(y, yi) in x.list" :key="yi + '_list'">{{ y.text }}</li>
                    </ul>
                    <ol v-if="x.listType === 'ol'" class="text-left" style="font-size: 18px">
                      <li v-for="(y, yi) in x.list" :key="yi + '_list'">
                        {{ y.text }}
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="mt-6 d-flex align-center rounded-lg bg-white pa-3" style="background-color: white">
                  <div class="ai-sub text-left mr-2">{{ x.footer }}</div>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :disabled="x.disabled" @click="GoRouter(x.url)">{{ x.btnText }}</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>
      </div>
    </v-container>

    <div v-for="(block, i) in cloudList" :key="`cloud-${i}`">
      <v-container class="list-item-card my-4">
        <v-row class="py-0">
          <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
            <div class="mb-2">
              <div class="block-title font-weight-bold mt-6 deep-purple--text text--darken-4 mr-1">
                <span v-html="formatTitle(block.title)"></span>
                <div v-if="block.freeTag !== 'hide'" class="free-tag">
                  <span class="text">{{ block.freeTag || "免費贈送" }}</span>
                  <span class="shine"></span>
                </div>
              </div>

              <div class="d-flex my-3">
                <div v-for="(item, idx) in block.items" :key="idx" :class="idx > 0 ? 'mx-3' : 'mr-3'">
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ item }}
                </div>
              </div>
              <ol>
                <li class="text-h6" v-for="(desc, dIdx) in block.descs" :key="dIdx">
                  {{ desc }}
                </li>
              </ol>

              <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block.btnUrl)" :style="block.btnStyle || {}">
                <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
                <span :style="block.btnTextStyle || {}">
                  {{ block.btnText }}
                </span>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
            <div class="px-0 px-sm-10 px-md-0">
              <SkeletonImg :src="block.img" :contain="block.contain"></SkeletonImg>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
            <SkeletonImg :src="block.img" class="px-0 px-sm-10 px-md-0" :contain="block.contain"></SkeletonImg>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="d-flex justify-center">
      <div class="home-block">
        <div class="py-0">
          <div class="d-flex justify-center">
            <div class="home-block-icon-bg">
              <v-icon color="#304FFE">mdi-domain</v-icon>
            </div>
          </div>
          <div align="center" class="d-flex justify-center align-center">
            <div class="font-weight-bold home-subtitle">
              <span>勞動法務風險防護</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-container v-for="(block, i) in lawList" :key="`law-${i}`" class="list-item-card my-4">
      <v-row class="py-0">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="mb-2">
            <div class="block-title font-weight-bold deep-purple--text text--darken-4 mr-1">
              <span v-html="formatTitle(block.title)"></span>
              <div v-if="block.freeTag !== 'hide'" class="free-tag">
                <span class="text">{{ block.freeTag || "免費贈送" }}</span>
                <span class="shine"></span>
              </div>
            </div>
            <div class="d-flex my-3">
              <div v-for="(item, idx) in block.items" :key="idx" :class="{ 'mx-3': idx > 0 }">
                <v-icon small>mdi-check-circle</v-icon>
                {{ item }}
              </div>
            </div>
            <ol>
              <li class="text-h6" v-for="(desc, dIdx) in block.descs" :key="dIdx">
                {{ desc }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block.btnUrl)" :style="block.btnStyle || {}">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span :style="block.btnTextStyle || {}">
                {{ block.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <SkeletonImg :src="block.img" class="px-0 px-sm-10 px-md-0"></SkeletonImg>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <SkeletonImg :src="block.img"></SkeletonImg>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div class="d-flex justify-center">
      <div class="home-block">
        <div class="py-0">
          <div class="d-flex justify-center">
            <div class="home-block-icon-bg">
              <v-icon color="#304FFE">mdi-domain</v-icon>
            </div>
          </div>
          <div align="center" class="d-flex justify-center align-center">
            <div class="font-weight-bold home-subtitle">
              <span>企業市場擴展</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(block, i) in managementList" :key="`management-${i}`">
      <v-container class="list-item-card my-4">
        <v-row class="py-0">
          <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
            <div class="px-0 px-sm-10 px-md-0 mb-2">
              <div class="block-title font-weight-bold mt-6 deep-purple--text text--darken-4 mr-1">
                <span v-html="formatTitle(block.title)"></span>
                <div v-if="block.freeTag !== 'hide'" class="free-tag">
                  <span class="text">{{ block.freeTag || "免費贈送" }}</span>
                  <span class="shine"></span>
                </div>
              </div>

              <div class="d-flex my-3">
                <div v-for="(item, idx) in block.items" :key="idx" :class="idx > 0 ? 'mx-3' : 'mr-3'">
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ item }}
                </div>
              </div>
              <ol>
                <li class="text-h6" v-for="(desc, dIdx) in block.descs" :key="dIdx">
                  {{ desc }}
                </li>
              </ol>

              <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block.btnUrl)" :style="block.btnStyle || {}">
                <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
                <span :style="block.btnTextStyle || {}">
                  {{ block.btnText }}
                </span>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
            <div class="px-0 px-sm-10 px-md-0">
              <SkeletonImg :src="block.img" :contain="block.contain"></SkeletonImg>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
            <SkeletonImg :src="block.img" class="px-0 px-sm-10 px-md-0" :contain="block.contain"></SkeletonImg>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="d-flex justify-center">
      <div class="home-block">
        <div class="py-0 pb-10">
          <div class="d-flex justify-center">
            <div class="home-block-icon-bg">
              <v-icon color="#304FFE">mdi-domain</v-icon>
            </div>
          </div>
          <div align="center" class="d-flex justify-center align-center">
            <div class="font-weight-bold home-subtitle">
              <span>勞動法務講座及課程</span>
            </div>
          </div>
          <div class="d-flex justify-center home-subtitle text-h4 text-md-h3">（相當於免費）</div>
        </div>
      </div>
    </div>
    <v-container v-for="(block, i) in lessonList" :key="`lesson-${i}`" class="list-item-card my-4">
      <v-row class="py-0">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0 mb-2">
            <div class="block-title font-weight-bold deep-purple--text text--darken-4 mr-1">
              <span v-html="formatTitle(block.title)"></span>
              <div v-if="block.freeTag !== 'hide'" class="free-tag">
                <span class="text">{{ block.freeTag || "免費贈送" }}</span>
                <span class="shine"></span>
              </div>
            </div>
            <div class="d-flex my-3">
              <div v-for="(item, idx) in block.items" :key="idx" :class="idx > 0 ? 'mx-3' : 'mr-3'">
                <v-icon small>mdi-check-circle</v-icon>
                {{ item }}
              </div>
            </div>
            <ol>
              <li class="text-h6" v-for="(desc, dIdx) in block.descs" :key="dIdx">
                {{ desc }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block.btnUrl)" :style="block.btnStyle || {}">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span :style="block.btnTextStyle || {}">
                {{ block.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <SkeletonImg :src="block.img" class="px-0 px-sm-10 px-md-0"></SkeletonImg>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <SkeletonImg :src="block.img"></SkeletonImg>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- <div style="background-color: #faf8f5">
      <v-container>
        <v-row>
          <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
            <div class="px-0 px-sm-10 px-md-0">
              <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
                <span v-html="formatTitle(block3.title)"></span>
              </div>
              <div class="d-flex my-3">
                <div>
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block3.item1 }}
                </div>
                <div class="mx-3">
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block3.item2 }}
                </div>
                <div>
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block3.item3 }}
                </div>
              </div>
              <div class="text-h6">{{ block3.desc }}</div>
              <v-btn x-large color="#00000061" rounded class="my-6">
                <v-icon size="17" class="mr-2" color="white">mdi-arrow-right</v-icon>
                <span class="white--text">
                  {{ block3.btnText }}
                </span>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
            <SkeletonImg :src="block3.img" class="px-0 px-sm-10 px-md-0"></SkeletonImg>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
            <div class="px-0 px-sm-10 px-md-0">
              <SkeletonImg :src="block3.img"></SkeletonImg>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <v-container class="py-10 px-4 px-sm-6">
      <div class="text-h5 text-md-h4 font-weight-bold mb-2 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '52px' }">
        <span v-html="formatTitle(block5.title)"></span>
      </div>
      <v-row class="mb-10">
        <v-col cols="6" md="4" v-for="(x, index) in block5.items" :key="index" align="left">
          <div class="d-flex align-center" align="left">
            <div>
              <v-img :src="x.icon" contain width="60" height="60"></v-img>
            </div>
            <template v-if="index + 1 < block5.items.length" class="my-4">
              <v-img :src="x.arraw" contain max-width="40" class="ml-6"></v-img>
            </template>
          </div>
          <div class="mb-2 text-md-h6 font-weight-bold">{{ x.text }}</div>
          <div class="text-md-h6">{{ x.desc }}</div>
          <div></div>
        </v-col>
      </v-row>
    </v-container>
    <Footer2 />
    <ShareDialog v-model="showShare" />
  </div>
</template>

<script>
import { openLoginDialog } from "@/utils/loginDialog";
import Header2 from "../components/Common/Header2.vue";
import Footer2 from "@/components/Common/Footer2.vue";
import ShareDialog from "@/components/Common/ShareDialog.vue";
import SkeletonImg from "@/components/Common/SkeletonImg.vue";

import { Account_Count } from "@/apis/api";

import {} from "@/apis/api";
export default {
  components: { Header2, Footer2, ShareDialog, SkeletonImg },
  name: "Home",
  data() {
    return {
      accountCounts: null,
      showShare: false,
      lineLogo: require("@/assets/image/home/line_logo.png"),
      pfLogo: require("@/assets/image/home/pf_logo.svg"),
      logo30: require("@/assets/image/ai/金豐30.svg"),
      image_alliance: require("@/assets/image/home/雙強聯手.jpg"),
      image_lg2: require("@/assets/image/home/小芋頭企業戰略系統.png"),
      image_sm2: require("@/assets/image/home/小芋頭企業戰略系統S.png"),
      blockAI: [
        {
          title: "免費金豐勞動法務 AI 智能諮詢系統(人資的最強大腦，老板的救星)",
          icon: require("@/assets/image/ai/金豐ai公版icon.svg"),
          img: require("@/assets/image/ai/公版.svg"),
          list: [
            {
              text: "透過專業強大的 AI 系統，免費諮詢您的勞動權利，創造勞資雙贏！",
            },
            {
              text: "最強的人資管理 AI 大腦，免費快速得到相對應的法律內容及回答！",
            },
          ],
          listType: "ul",
          footer: "免費金豐勞動法務 AI 智能諮詢系統",
          btnText: "前往查看",
          url: process.env.VUE_APP_MAIN_AICHAT_BASE_URL,
        },
        {
          title: "企業AI行銷會員",
          icon: require("@/assets/image/ai/銀徽章.svg"),
          img: require("@/assets/image/ai/企業行銷會員.svg"),
          list: [{ text: "建立屬於企業的AI行銷網站！" }, { text: "建立24小時AI客服互動系統！" }, { text: "建立屬於企業的會員獲客系統！" }, { text: "建立專屬於企業的知識資料庫！" }, { text: "適用業務行銷個人及微型企業！" }, { text: "正式方案敬請期待！" }],
          listType: "ol",
          // 早鳥預購已於 2026-10-07 結束：卡片保留，按鈕停用；要恢復把 footer、btnText 改回並拿掉 disabled
          footer: "早鳥預購已結束",
          btnText: "敬請期待",
          disabled: true,
          url: process.env.VUE_APP_MAIN_AICHAT_BASE_URL + "/pre-order?lv=1",
        },
        {
          title: "企業AI智庫會員",
          icon: require("@/assets/image/ai/金徽章.svg"),
          img: require("@/assets/image/ai/企業智庫會員.svg"),
          list: [{ text: "建立屬於企業的AI行銷網站！" }, { text: "建立24小時AI客服互動系統！" }, { text: "建立屬於企業的會員獲客系統！" }, { text: "建立專屬於企業的知識資料庫！" }, { text: "建立專屬於企業的AI智能培訓系統！" }, { text: "適用160多萬家中小企業！" }, { text: "正式方案敬請期待！" }],
          listType: "ol",
          // 早鳥預購已於 2026-10-07 結束：卡片保留，按鈕停用；要恢復把 footer、btnText 改回並拿掉 disabled
          footer: "早鳥預購已結束",
          btnText: "敬請期待",
          disabled: true,
          url: process.env.VUE_APP_MAIN_AICHAT_BASE_URL + "/pre-order?lv=2",
        },
      ],
      block1: {
        bgImg: require("@/assets/image/home/PrimaryKv_bg.png"),
        title: "小芋頭平台",
        title2: "提供中小企業一站式服務",
        desc: "一個ESG企業永續發展等服務的一站式平台，為中小企業乃至個人商家提供各項解決方案",
        btnText: "免費開始",
        btnUrl: "SignUp",
        item1: "一站登入任一使用，無須重複註冊",
        item2: " 提供免費和收費方案",
        img: require("@/assets/image/home/PrimaryKv_lg_1.png"),
        img2: process.env.VUE_APP_MAIN_BASE_URL + "/img/pre/PrimaryKv_mdsm.png",
      },
      quickForward: {
        title: "快速前往",
        items: [
          {
            text: "小芋頭社群",
            desc: "建立免費企業或社團會員網站",
            img: process.env.VUE_APP_MAIN_BASE_URL + "/img/pre/icon_home_tarosms.svg",
            url: process.env.VUE_APP_MAIN_SMS_BASE_URL,
          },
          {
            text: "小芋頭廣告 ",
            desc: "建立免費的社群輪播廣告",
            img: process.env.VUE_APP_MAIN_BASE_URL + "/img/pre/icon_home_ads.svg",
            url: "Ads",
          },
        ],
      },
      // 培訓考證區塊列表
      trainingList: [],

      cloudList: [
        {
          title: "免費金豐OA行動辦公室軟體系統使用（10人以下永久免費使用）",
          items: ["企業勞動法務專業軟體"],
          descs: ["企業員工10人以內永久免費使用。", "指派專人免費導入企業使用軟體及教學。", "使用軟體系統建立勞工名卡（需保留5年）以及性騷擾、霸凌申訴專線以免受罰。", "本軟體系統不包含打卡系統及發薪系統。"],
          btnText: "立即申請免費軟體使用",
          btnUrl: "https://taro.kf-9595.com/product/40?a=102&variant=66",
          img: require("@/assets/image/home/oakv2.png"),
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "center" },
        },
      ],
      lawList: [
        {
          title: "免費透過AI學習勞動法律知識考證1日班培訓（勞動法律知識賦能）",
          items: ["考證單位：中華民國全國工業總會：企業勞動法務人員能力鑑定考證LLA證照"],
          descs: [
            "本課程將培訓「企業勞動法務管理專業」。在校大學生免費上課",
            "這是您的人生必上的一堂課，因為您不是老闆就是勞工請務必用心閱讀。",
            "完成【透過AI學習勞動法律知識】考證班6小時培訓之學員，可以獲得【中華民國全國工業總會】【企業勞動法務人員能力鑑定考證(LLA證照)】考證報名的考試資格!(每年5月及11月舉辦)",
            "歡迎邀約(中華民國全國工業總會勞動教育專家講師)授課培訓。",
            "本服務由金豐企管作為培訓單位。",
          ],
          btnText: "免費考證課程報名 ",
          btnUrl: "https://taro.kf-9595.com/product/36/%E9%80%8F%E9%81%8Eai%E5%AD%B8%E7%BF%92%E6%B3%95%E5%BE%8B%E7%9F%A5%E8%AD%981%E6%97%A5%E7%8F%AD",
          img: require("@/assets/image/home/llaclass.png"),
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },
        {
          title: "企業勞動法務管理解決方案（免費顧問專家諮詢）",
          items: ["企業勞動法務全面管理B案"],
          descs: [
            "勞資糾紛是可以預防跟解決的，企業要避免勞資糾紛，創造勞資雙贏。實現ESG的【S】員工薪資與福利，達成企業【留】才不【流】才。",
            "透過專人服務說明，企業可以了解如何解決企業經營上的勞資問題以避免處罰及訴訟危機。（本專案已經服務近7000家以上的企業）",
            "透過專業顧問師執案，量身打造企業勞動法務的全面管理。",
          ],
          btnText: "勞資爭議解決方案顧問諮詢",
          btnUrl: "https://taro.kf-9595.com/product/48/%E5%8B%9E%E5%8B%95%E6%B3%95%E5%8B%99%E7%AE%A1%E7%90%86%E5%B0%88%E6%A1%88",
          img: require("@/assets/image/home/Consulting.png"),
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },
        {
          title: "免費法律諮詢申請（聯盟律師免費諮詢）",
          items: ["免費使用"],
          descs: ["本服務由金豐企管合作的聯盟的律師事務所提供免費諮詢服務。", "人的一生中多少會面臨一些法律問題，金豐集團提供有效客戶1~2次免費法律諮詢服務。", "小芋頭平台會員提供1年1次，每次一小時的免費諮詢。"],
          btnText: "免費法律諮詢申請",
          btnUrl: "https://taro.kf-9595.com/product/46/%E6%B3%95%E5%BE%8B%E8%AB%AE%E8%A9%A2%E9%A1%A7%E5%95%8F%E5%B0%88%E6%A1%88",
          img: require("@/assets/image/home/lawkv.png"),
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "left", whiteSpace: "normal" },
          btnTextStyle: { width: "100%", textAlign: "left" },
        },
      ],
      lessonList: [
        {
          title: "【企業講座】「勞動事件法及性工法及勞工職業災害保險及保護法」通過後，企業如何因應（課程費用1000元，反饋8000元服務，倒賺7000元，雇主獨享）",
          items: ["免費諮詢"],
          descs: [
            "近1,000場以上的講座，每月台北、台中、台南、高雄舉辦，場場爆滿。",
            "人生必上的一場講座，因為您不是老板就是勞工，必須了解最新的勞動法律。",
            "企業被勞檢了嗎？有勞檢必有處罰，有處罰必有訴訟。",
            "贈送［透過Al學習法律知識1日班］課程，價值3000元。贈送［勞動法務到貴公司免費健檢諮詢］價值5000元。講座費用1000元，倒賺7000元，雇主獨享。",
          ],
          btnText: "企業勞動法務管理講座報名",
          btnUrl:
            "https://taro.kf-9595.com/product/38/%E4%BC%81%E6%A5%AD%E8%AC%9B%E5%BA%A7%E5%8B%9E%E5%8B%95%E4%BA%8B%E4%BB%B6%E6%B3%95%E5%8F%8A%E6%80%A7%E5%B7%A5%E6%B3%95%E5%8F%8A%E5%8B%9E%E5%B7%A5%E8%81%B7%E6%A5%AD%E7%81%BD%E5%AE%B3%E4%BF%9D%E9%9A%AA%E5%8F%8A%E4%BF%9D%E8%AD%B7%E6%B3%95%E9%80%9A%E9%81%8E%E5%BE%8C%E4%BC%81%E6%A5%AD%E5%A6%82%E4%BD%95%E5%9B%A0%E6%87%89",
          img: require("@/assets/image/home/Lecture.png"),
          freeTag: "相當於免費",
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },
        {
          title: "勞資爭議調處人員訓練班(1日班)(高雄線下課程) （退職軍人及眷屬政府全額補助）",
          items: [],
          descs: [
            "若本課程若需榮服會全額補助需先向當地榮服會申請通過後再向平台購買課程。",
            "本課程全國各地報名退職軍人或眷屬人員需至高雄線下實體上課。",
            "本課程結束時間為17﹕00，但學員需另留30分鐘頒發結業證書及填寫心得報告。",
            "本課程報名完成後不提供退費處理，請慎重報名購買。",
            "完成培訓之學員，可以獲得【中華民國全國工業總會】【企業勞動法務人員能力鑑定考證(LLA證照)】考證報名的考試資格!(每年5月及11月舉辦)。",
            "本课程學員可以在本公司簽約創業就業。",
          ],
          btnText: "勞資爭議調處人員訓練班",
          btnUrl: "https://taro.kf-9595.com/product/39/%E5%8B%9E%E8%B3%87%E7%88%AD%E8%AD%B0%E8%AA%BF%E8%99%95%E4%BA%BA%E5%93%A1%E8%A8%93%E7%B7%B4%E7%8F%AD1%E6%97%A5%E7%8F%AD%E9%AB%98%E9%9B%84%E7%B7%9A%E4%B8%8B%E8%AA%B2%E7%A8%8B?openExternalBrowser=1",
          img: require("@/assets/image/home/勞資爭議調處 人員訓練班 (1).png"),
          freeTag: "相當於免費",
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },
        {
          title: "金豐企業大學專家講師系列講座（直播及錄播免費課程）",
          items: ["免費講座"],
          descs: [
            "金豐企業大學於2019.2.22金豐集團高雄總部隆重成立。重點在建立新世代人力資源管理/學習系統、積極培訓精英人才、籌建知識管理體系、精實管理及勞資法務勞務管理運營。",
            "金豐企業大學專家講座系列課程提供平台所有閱讀人員免費的視訊直播課程，並於直播結束後提供錄播，讓閱讀者能深入學習專業的課程。",
            "所有專家講師課程均為系列課程，非單一課程，且對外免費公開，歡迎大家持續閱讀及分享。",
          ],
          btnText: "免費專家講師系列講座",
          btnUrl: "https://school.king-fong.com/?openExternalBrowser=1",
          img: require("@/assets/image/home/kingfonguniversity.png"),
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },

        {
          title: "免費勞動法務健檢及顧問諮詢服務（直接健檢並提供健檢報告，超過4萬人次點擊使用）",
          items: ["免費使用"],
          descs: ["免費提供雇主及勞工勞動法務的責任及權利的健康檢查，並提供健檢報告及評分！", "提供顧問師免費顧問諮詢及健檢報告說明！", "已經超過4萬人以上至健檢網健檢，企業合法經營，保障勞工權利，創造勞資雙贏！"],
          btnText: "免費勞動法務健檢 ",
          btnUrl: "https://labor.kf-9595.com/",
          img: require("@/assets/image/home/kv.png"),
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },
        {
          title: "時尚與企業精神的交匯，企業美學營造",
          items: ["企業禮贈品", "企業制服", "時尚美感訂製"],
          descs: [
            "由台灣設計師品牌Yentity，設計總監董亭言，結合品牌訴求、企業精神、企業識別與時尚設計美學。為企業創造出兼具時尚美感與實用性的企業制服與企業禮贈。",
            "以服裝匠心結合專業訴求，創造出獨屬每一個企業的現代時尚美感。以長年累積的布料素材運用經驗，讓好看、好穿的使用體驗結合，讓美學不只是視覺，更走入生活，走入內心。",
            "透過美感設計與包裝，透過企業專屬訂製印花、精心包裝、精選材質，為企業打造專屬禮贈。將企業精神與心意已時尚美感，豐富合作的無限可能。",
          ],
          btnText: "探索品牌，一同創造時尚新面貌",
          btnUrl: "Yentity",
          img: require("@/assets/projectYentity/特堤_入口網頁_橫式_01.webp"),
          freeTag: "hide",
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "left", whiteSpace: "normal" },
          btnTextStyle: { width: "100%", textAlign: "left" },
        },
        {
          title: "ESG碳盤查及認證諮詢（免費ISO顧問業務諮詢）",
          items: ["ISO各項認證"],
          descs: ["本服務由金豐集團合作的德利企管公司提供服務。", "企業為什麼要做碳盤查及碳足跡？因為台灣2050年要做到淨零排放，您的企業不做都不行。"],
          btnText: "免費碳排查及認證諮詢",
          btnUrl: "https://taro.kf-9595.com/product/58/esg%E7%A2%B3%E7%9B%A4%E6%9F%A5%E5%8F%8A%E8%AA%8D%E8%AD%89%E8%AB%AE%E8%A9%A2",
          img: require("@/assets/image/home/esgcarbonreduction.png"),
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "left", whiteSpace: "normal" },
          btnTextStyle: { width: "100%", textAlign: "left" },
        },
        {
          title: "健康與心意的交匯，打造現代健康禮贈美學",
          items: ["保健食品組合", " 中秋健康禮盒", "客製化提袋 / 祝福小卡"],
          descs: [
            "朝和生醫為世紀民生科技股份有限公司（股票代號：5314）旗下健康品牌，是台灣第一家吃的外泌體EOB686(植萃)保健品牌。結合健康科技、營養科學與現代生活美學，打造兼具質感與實用性的健康禮盒，讓送禮不只是形式，更是一份傳遞關心與健康的心意。",
            "以「送健康」為理念，朝和生醫精選多款保健食品組合，針對現代人日常保養需求規劃健康禮盒，將營養補給、質感包裝與節慶送禮結合，創造兼具實用性與品牌形象的健康禮贈選擇。",
            "透過中秋節早鳥禮盒訂購服務，提供企業贈禮、商務送禮與親友節慶送禮更多元的搭配方案。並可依需求提供客製化提袋、專屬祝福小卡與企業贈禮規劃，讓每一份禮盒都能展現專屬心意與品牌溫度。",
          ],
          btnText: "送禮自用兩相宜。朝和生醫",
          btnUrl: "Jhaoho",
          img: require("@/assets/image/home/Jhaoho_home.jpg"),
          freeTag: "hide",
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "left", whiteSpace: "normal" },
          btnTextStyle: { width: "100%", textAlign: "left" },
        },
      ],
      // 企業經營區塊列表
      managementList: [
        {
          title: "建立免費的社群輪播廣告（平台免費廣告）",
          items: ["廣告曝光", "免費使用"],
          descs: ["免費企業廣告投放，讓近萬人的小芋頭免費企業及社團會員網站人員可以看到您的輪播廣告。", "小芋頭免費廣告可快速連結您的網頁，並提供廣告搜尋，讓您的商品被更多人看見。"],
          btnText: "免費輪播廣告首頁",
          btnUrl: "Ads",
          img: require("@/assets/image/home/Adskv.png"),
          contain: true,
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },
        {
          title: "建立免費企業或社團會員網站（企業獲客系統）",
          items: ["會員管理網站", "免費使用"],
          descs: [
            "企業會員網站至少需要30萬以上的建置費用及每年的維護費用，現在您可以在小芋頭平台免費擁有，無任何費用。",
            "企業會員網站可以協助您發放最新消息，促銷您的商品活動，並累積會員數量。",
            "社團會員網站可以協助您的社團新會員快速認識其他舊會員，會長並可以將本年度的活動花絮記錄在社群網站。讓會員了解每屆會長經營會務的用心。",
            "會員網站可以（公開）也可以（不公開），方便大家管理。會員參加多個小芋頭社團網站可以方便會員共同管理及參與。",
          ],
          btnText: "免費會員網站首頁",
          btnUrl: "https://tarosms.kf-9595.com/",
          img: require("@/assets/image/home/mskv.png"),
          contain: true,
          btnStyle: { display: "inline-flex", flexDirection: "column", alignItems: "center", whiteSpace: "normal" },
          btnTextStyle: { whiteSpace: "normal", textAlign: "left" },
        },
      ],

      // 策略合作區塊列表
      strategicList: [],

      // 獨立的 Block 3 (因為樣式特殊，保留在獨立結構)
      block3: {
        img: require("@/assets/image/home/hrkv.png"),
        title: "建立企業工作站 (架構中尚未開放)",
        item1: "HR 人資軟體",
        item2: "免費使用",
        item3: "進階收費方案",
        desc: "涵蓋 8 大內容，一套完整的企業勞動法務管理的系統，雲端整合，免去所有紙本文件",
        btnText: "企業工作站首頁",
      },
      block5: {
        title: "快速註冊快速啟用",
        desc: "免費使用! 我們只會在您主動啟用進階功能時提供收費方案",
        items: [
          {
            icon: require("@/assets/image/home/Icon_home_register.svg"),
            arraw: require("@/assets/image/home/arrow.svg"),
            text: "註冊小芋頭",
            desc: "使用第3方或信箱註冊小芋頭平台",
          },
          {
            icon: require("@/assets/image/home/Icon_home _going.svg"),
            arraw: require("@/assets/image/home/arrow.svg"),
            text: "前往軟體服務",
            desc: "從小芋頭平台挑選欲使用的服務並前往",
          },
          {
            icon: require("@/assets/image/home/Icon_home _free.svg"),
            arraw: require("@/assets/image/home/arrow.svg"),
            text: "免費開始使用",
            desc: "部分服務將在首次使用時指引您完成設置",
          },
        ],
      },
    };
  },
  metaInfo() {
    return {
      title: "小芋頭企業服務平台",
      meta: [
        {
          name: "description",
          content: "提供中小企業一站式軟體服務",
        },
        {
          property: "og:title",
          content: "小芋頭企業服務平台",
        },
        {
          property: "og:description",
          content: "提供中小企業一站式軟體服務",
        },
        {
          property: "og:image",
          content: require("@/assets/image/home/fb_meta.png"),
        },
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.$meta().refresh();
    next();
  },

  created() {
    this.$meta().refresh();
  },
  mounted() {
    this.$meta().refresh();
    this.getAccountCounts();
  },
  methods: {
    getAccountCounts() {
      this.accountCounts = "計算中...";
      Account_Count()
        .then((res) => {
          console.log(res.data);
          this.accountCounts = res.data;
        })
        .catch((err) => {
          console.error(err.response.data);
          this.accountCounts = "獲取失敗，請重新整理頁面";
        });
    },
    // 1. 這是核心邏輯：把當前的 query 參數附加到目標網址上
    appendCurrentQueryParams(targetUrl) {
      try {
        // 從當前路由取得需要的參數
        const { refc, openExternalBrowser } = this.$route.query;

        // 準備要帶過去的參數物件
        const paramsToAdd = {};
        if (refc) paramsToAdd.refc = refc;
        if (openExternalBrowser) paramsToAdd.openExternalBrowser = openExternalBrowser;

        // 【新增】如果已經登入，主動帶上 Token 實作跨站無感登入
        const token = localStorage.getItem("_token");
        const emailEncrypt = localStorage.getItem("_emailEncrypt");
        if (token) paramsToAdd.t = token;
        if (emailEncrypt) paramsToAdd.emailEncrypt = emailEncrypt;

        // 如果當前網址沒有這些參數，且 localStorage 也沒票，就直接回傳原本的 url
        if (Object.keys(paramsToAdd).length === 0) {
          return targetUrl;
        }

        // 判斷 targetUrl 是相對路徑還是絕對路徑，以便使用 URL API
        const isAbsolute = targetUrl.startsWith("http") || targetUrl.startsWith("//");
        const baseUrl = window.location.origin;

        // 建立 URL 物件來處理參數
        const urlObj = new URL(targetUrl, isAbsolute ? undefined : baseUrl);

        // 將參數加進去
        Object.keys(paramsToAdd).forEach((key) => {
          // 只有當目標網址原本沒有這個參數時才加入，避免重複或覆蓋目標原本的設定
          if (!urlObj.searchParams.has(key)) {
            urlObj.searchParams.set(key, paramsToAdd[key]);
          }
        });

        // 如果原本是絕對路徑，回傳完整 href
        if (isAbsolute) {
          return urlObj.href;
        }

        // 如果原本是相對路徑，回傳路徑 + 參數 + hash (去除 domain)
        return urlObj.pathname + urlObj.search + urlObj.hash;
      } catch (e) {
        console.error("URL append param error:", e);
        return targetUrl; // 發生錯誤時，至少回傳原網址，確保功能不斷掉
      }
    },
    GoRouter(url) {
      if (url === "SignUp") {
        // 原地跳出註冊對話框（子站自訂網域會改到平台註冊，見 utils/loginDialog.js）
        const raw = this.$route.query.refc;
        openLoginDialog({ refc: Array.isArray(raw) ? raw[0] : raw, view: "SignUp" });
        return;
      }
      // 一般邏輯：處理網址後跳轉
      const finalUrl = this.appendCurrentQueryParams(url);

      // 判斷是否為站內路由還是外部連結
      // 由於你的原始代碼全部使用 window.location.href，這裡保持一致
      window.location.href = finalUrl;
    },
    AddLine() {
      let newWindow = window.open();
      newWindow.location.href = "https://lin.ee/l07cEKr";
    },
    /** 標題遇到括號時自動斷行 */
    formatTitle(title) {
      if (!title) return "";
      // 支援全形（）和半形()兩種括號，在第一個左括號前插入 <br>
      return title.replace(/([（(])/, "<br>$1");
    },
    GoBlank(url) {
      const finalUrl = this.appendCurrentQueryParams(url);
      const newWin = window.open();
      newWin.location.href = finalUrl;
    },
  },
};
</script>

<style scoped>
.block1-bg {
  background: #e9deff;
  background-image: url("~@/assets/image/home/PrimaryKv_bg.png");
  height: 478px;
  background-repeat: no-repeat;
  background-position: top right;
  /* background-size: contain; */
}

@media screen and (max-width: 1280px) {
  .block1-bg {
    height: 538px;
  }
}

@media screen and (max-width: 960px) {
  .block1-bg {
    height: auto;
  }
}

.v-card {
  transition: opacity 0.2s ease-in-out;
  opacity: 0.8;
}

.v-card:not(.on-hover) {
  opacity: 1;
}

.quick-go {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .quick-go {
    border: none;
  }
}

.shareBtn {
  border-radius: 500px;
  border: 1px;
  background: #ffffff;
  border: 1px solid var(--color-Primary-theme-1, #7c4dff);
}

.home-subtitle {
  text-align: center;
  font-family: "Noto Sans TC";
  font-size: 54px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  /* 85.5px */
  letter-spacing: 0.5px;
  background: linear-gradient(92deg, #6334e5 26.31%, #105cff 99.15%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media screen and (max-width: 600px) {
  .home-subtitle {
    font-size: 40px;
  }
}

.block-title {
  font-size: 32px;
  line-height: 1.5;
}

@media screen and (max-width: 600px) {
  .block-title {
    font-size: 24px;
  }
}

.home-block {
  max-width: 1280px;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 16px 0px;
  margin-top: 40px;
  border-radius: 80px 80px 0 0;
  background: linear-gradient(180deg, #d7eeff 0%, #fff 100%);
}

@media screen and (max-width: 600px) {
  .home-block {
    border-radius: 40px 40px 0 0;
  }
}

.home-block-icon-bg {
  display: flex;
  padding: var(--spacing-2-8, 8px) var(--spacing-4-16, 16px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--spacing-7-28, 28px);
  background: #fff;
}

.list-item-card {
  padding: 24px;
  border-radius: 24px;
  border: 1px solid rgb(0 0 0 / 12%);
  width: calc(100% - 32px) !important;
  max-width: calc(1280px - 32px) !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

@media screen and (max-width: 600px) {
  .list-item-card {
    padding: 24px 12px;
  }
}

.ai-title {
  color: var(--color-Primary-title, #4934a6);
  font-size: 29px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.25px;
}

@media screen and (max-width: 600px) {
  .ai-title {
    font-size: 23px;
  }
}

.ai-sub {
  color: var(--color-text-primary-87, rgba(0, 0, 0, 0.87));
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.25px;
}

.ai-card {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid var(--blue-grey-blue-grey-lighten-5, #eceff1);
  background: linear-gradient(180deg, #fff 0%, #d7eeff 100%);
  position: relative;
}

/* 響應式圖片控制 */
.image-lg {
  display: block;
}

.image-sm {
  display: none;
  width: 100%;
}

@media screen and (max-width: 600px) {
  .image-lg {
    display: none;
  }

  .image-sm {
    display: block;
  }
}

/* Block1 響應式圖片控制 */
.block1-img-lg {
  display: block;
  object-position: 0 0px;
}

.block1-img-sm {
  display: none;
}

@media screen and (min-width: 1240px) {
  .block1-img-lg {
    object-position: 0 -30px;
  }
}

@media screen and (max-width: 960px) {
  .block1-img-lg {
    display: none;
  }

  .block1-img-sm {
    display: block;
  }
}

.mid-title {
  border-radius: 24px;
  background: linear-gradient(90deg, #fbeede 0%, #e3fffa 100%);
  padding: 24px 10px;
  color: #4934a6;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  /* 48px */
  letter-spacing: 0.5px;
}

@media screen and (max-width: 700px) {
  .mid-title {
    font-size: 24px;
  }
}

.free-tag {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, #e60076, #c6005c);
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  padding: 0px 22px;
  border-radius: 999px;
  height: 40px;
  overflow: hidden;
  vertical-align: middle;
  white-space: nowrap;
  transform: translateY(-4px);
  /* 補償基線偏差 */
}

@media screen and (max-width: 600px) {
  .free-tag {
    height: 32px;
  }
}

.free-tag .text {
  position: relative;
  z-index: 2;
}

.free-tag .shine {
  position: absolute;
  top: 0;
  left: -60%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, rgba(251, 100, 182, 0) 0%, rgba(251, 100, 182, 0.2) 30%, rgba(251, 100, 182, 0.9) 50%, rgba(251, 100, 182, 0.2) 70%, rgba(251, 100, 182, 0) 100%);
  transform: skewX(-20deg);
  animation: shineMove 2.8s ease-in-out infinite;
}

@keyframes shineMove {
  0% {
    left: -70%;
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  35% {
    left: 120%;
    opacity: 1;
  }

  45% {
    opacity: 0;
  }

  100% {
    left: 120%;
    opacity: 0;
  }
}
</style>
